<template>
  <PageTemplate title="Fale Conosco">
    <v-row class="mt-4" justify="center">
      <v-col cols="12" md="7" lg="6">
        <ContactForm
          :action="files + formAction"
          response-to="/fale-conosco/obrigado"
        />
      </v-col>
    </v-row>
  </PageTemplate>
</template>

<script>
import PageTemplate from "../components/templates/PageTemplate.vue";
import ContactForm from "../components/forms/ContactForm.vue";

export default {
  data: () => ({
    formAction: "/rest/email/contact-us",
  }),
  components: {
    PageTemplate,
    ContactForm,
  },
};
</script>
